export default __webpack_public_path__ + "static/media/Aerospace_Defense_Award.f71fdd13.png";